import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import FaceIcon from "@mui/icons-material/Face";
import { List, ListItemText, Tooltip, Typography } from "@mui/material";
import "./Dashboard.css";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  BuyLinks,
  SellLinks,
  RedeemLinks,
  ContentLinks,
  PartnerLinks,
  ReportsLinks,
  sidebarLinks,
  UserLinks,
  JewelleryLinks,
  OperationsLinks,
} from "../../utils/links";
import { FaAngleDown } from "react-icons/fa";

import axios from "axios";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import axiosInstance from "../../utils/axiosInstance";

// const drawerWidth = 250;
const drawerWidthDesktop = 250; // ✅ Keep your existing drawer width
const drawerWidthMobile = 430; // ✅ Slightly bigger sidebar for mobile

const openedMixin = (theme, isMobile) => ({
  width: isMobile ? drawerWidthMobile : drawerWidthDesktop,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "isMobile",
})(({ theme, open, isMobile }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: isMobile ? drawerWidthMobile : drawerWidthDesktop,
    width: `calc(100% - ${
      isMobile ? drawerWidthMobile : drawerWidthDesktop
    }px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "isMobile",
})(({ theme, open, isMobile }) => ({
  width: isMobile ? drawerWidthMobile : drawerWidthDesktop,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme, isMobile),
    "& .MuiDrawer-paper": openedMixin(theme, isMobile),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function Dashboard() {
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ Mobile screen check
  const isTab = useMediaQuery(theme.breakpoints.down("md"));
  const drawerWidth = {
    xs: "75%", // ✅ On extra-small screens (mobile) → take 75% width
    sm: 260, // ✅ On small & up (tablet/desktop) → fixed px
  };
  // const [timeLeft, setTimeLeft] = useState("");
  // const loginData = useSelector((state) => state.login?.login);
  // const { last_login, last_login_ip, session_expires_at, name } =
  //   loginData || {};

  // Countdown timer logic
  // useEffect(() => {
  //   if (!session_expires_at) return; // exit if session_expires_at is undefined

  //   // const expireTime = new Date(session_expires_at).getTime();
  //   // if (isNaN(expireTime)) return; // exit if date is invalid

  //   const interval = setInterval(() => {
  //     const now = Date.now();
  //     const diff = expireTime - now;

  //     if (diff <= 0) {
  //       setTimeLeft("Session Expired");
  //       clearInterval(interval);

  //       // Call your existing logout function
  //       callLogoutAPI();
  //       return;
  //     }

  //     const hours = Math.floor(diff / (1000 * 60 * 60));
  //     const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  //     const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  //     setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, [session_expires_at]);

  const location = useLocation();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open1 = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [open, setOpen] = useState(!isMobile);
  // ✅ On mobile → closed by default, desktop → open by default

  // const [open, setOpen] = React.useState(true)
  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const toggleDrawer = () => {
    setOpen(!open);
    setDropdownOpen(!false); ///// close/open automatic Reports Link
    setPartnerDropdownOpen(!false);
    setContentDropdownOpen(!false);
    setRedeemDropdownOpen(!false);
    setBuyDropdownOpen(!false);
    setSellDropdownOpen(!false);
    setUserDropdownOpen(!false);
    setJewelleryDropdownOpen(!false);
    setOperationsDropdownOpen(!false); ///// close/open automatic Operations Link
  };

  const [partnerDropdownOpen, setPartnerDropdownOpen] = useState(false);
  const togglePartnerDropdown = () => setPartnerDropdownOpen((prev) => !prev);

  const [redeemDropdownOpen, setRedeemDropdownOpen] = useState(false);
  const toggleRedeemDropdown = () => setRedeemDropdownOpen((prev) => !prev);

  const [buyDropdownOpen, setBuyDropdownOpen] = useState(false);
  const toggleBuyDropdown = () => setBuyDropdownOpen((prev) => !prev);

  const [sellDropdownOpen, setSellDropdownOpen] = useState(false);
  const toggleSellDropdown = () => setSellDropdownOpen((prev) => !prev);

  const [contentDropdownOpen, setContentDropdownOpen] = useState(false);
  const toggleContentDropdown = () => setContentDropdownOpen((prev) => !prev);

  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const toggleUserDropdown = () => setUserDropdownOpen((prev) => !prev);

  const [jewelleryDropdownOpen, setJewelleryDropdownOpen] = useState(false);
  const toggleJewelleryDropdown = () =>
    setJewelleryDropdownOpen((prev) => !prev);

  const [operationsDropdownOpen, setOperationsDropdownOpen] = useState(false);
  const toggleOperationsDropdown = () =>
    setOperationsDropdownOpen((prev) => !prev);

  const apiResponse = useSelector((state) => state.login.login.role) || {};

  const roleResponse = useSelector((state) => state?.login?.login?.role) || {};
  // contains all links
  const filteredLinks = sidebarLinks?.filter((item) => {
    const permissions = apiResponse[item.ApiKeyForSideBar];
    return permissions && permissions.read === 1; // Show item if it has read permission
  });

  // contains filtered/separatse links
  const filteredUserLinks = UserLinks?.filter((item) => {
    const permissions = apiResponse[item.ApiKeyForSideBar];
    return permissions && permissions.read === 1; // Show item if it has read permission
  });
  const filteredBuyLinks = BuyLinks?.filter((item) => {
    const permissions = apiResponse[item.ApiKeyForSideBar];
    return permissions && permissions.read === 1; // Show item if it has read permission
  });
  const filteredSellLinks = SellLinks?.filter((item) => {
    const permissions = apiResponse[item.ApiKeyForSideBar];
    return permissions && permissions.read === 1; // Show item if it has read permission
  });
  const filteredRedeemLinks = RedeemLinks?.filter((item) => {
    const permissions = apiResponse[item.ApiKeyForSideBar];
    return permissions && permissions.read === 1; // Show item if it has read permission
  });
  const filteredContentLinks = ContentLinks?.filter((item) => {
    const permissions = apiResponse[item.ApiKeyForSideBar];
    return permissions && permissions.read === 1; // Show item if it has read permission
  });
  const filteredPartnerLinks = PartnerLinks?.filter((item) => {
    const permissions = apiResponse[item.ApiKeyForSideBar];
    return permissions && permissions.read === 1; // Show item if it has read permission
  });
  const filteredReportsLinks = ReportsLinks?.filter((item) => {
    const permissions = apiResponse[item.ApiKeyForSideBar];
    return permissions && permissions.read === 1; // Show item if it has read permission
  });
  const filteredJewelleryLinks = JewelleryLinks?.filter((item) => {
    const permissions = apiResponse[item.ApiKeyForSideBar];
    return permissions && permissions.read === 1; // Show item if it has read permission
  });
  const filteredOperationsLinks = OperationsLinks?.filter((item) => {
    const permissions = apiResponse[item.ApiKeyForSideBar];
    return permissions && permissions.read === 1; // Show item if it has read permission
  });

  const handleMenuClick = () => {
    if (isMobile) {
      setOpen(false); // ✅ Auto-close only on mobile
    }
  };

  const navColor = "#4a2a7d";
  const callLogoutAPI = async () => {
    try {
      const url = `/logout`;
      localStorage.removeItem("token");
      localStorage.removeItem("persist:login");
      navigate("/login");
      const response = await axiosInstance.get(url);
    } catch (error) {
      if (error.response.data.messag == "Invalid Authentication") {
        localStorage.removeItem("token");
        navigate("/login");
      }
      console.log("error: ", error);
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      {/* -----------------------------------NAVBAR--------------------------------------------  */}
      {/* <AppBar position="fixed" open={open} isMobile={isMobile}>
       
        <Toolbar sx={{ bgcolor: navColor, color: "white" }}>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex" }}>
              {(!open || !isMobile) && (
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={toggleDrawer}
                  edge="start"
                  sx={{ marginRight: 1 }}
                >
                  <div className="group flex cursor-pointer items-center justify-center">
                    <div className="space-y-2">
                      <span className="block h-1 w-10 origin-center rounded-full bg-white"></span>
                      <span className="block h-1 w-8 origin-center rounded-full bg-white"></span>
                      <span className="block h-1 w-6 origin-center rounded-full bg-white"></span>
                    </div>
                  </div>
                </IconButton>
              )}

              {!open && (
                <img
                  src="/img/batukSmallLogo.png"
                  alt="batuk"
                  width="50px"
                  style={{ display: "flex", marginRight: "1rem" }}
                />
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "0px",
              }}
            >
              <Tooltip title={roleResponse.name}>
                <Button
                  id="basic-button"
                  aria-controls={open1 ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open1 ? "true" : undefined}
                  onClick={handleClick}
                >
                  <img src="/icons/account.png" alt="cart Logo" width="30px" />

                 
                </Button>
              </Tooltip>

              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open1}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <NavLink to="/resetpassword">
                  <MenuItem
                    sx={{
                      "&:hover": {
                        backgroundColor: navColor,
                        color: "white", // Change this color as per your requirement
                      },
                    }}
                    onClick={handleClose}
                  >
                    Reset Password
                  </MenuItem>
                </NavLink>

                <MenuItem
                  sx={{
                    "&:hover": {
                      backgroundColor: navColor,
                      color: "white", // Change this color as per your requirement
                    },
                  }}
                  onClick={callLogoutAPI}
                >
                  Logout
                </MenuItem>
              </Menu>
              
            </Box>
          </Box>
        </Toolbar>
      </AppBar> */}
      <AppBar position="fixed" open={open} isMobile={isMobile}>
        <Toolbar sx={{ bgcolor: navColor, color: "white" }}>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex" }}>
              {(!open || !isMobile) && (
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={toggleDrawer}
                  edge="start"
                  sx={{ marginRight: 1 }}
                >
                  <div className="group flex cursor-pointer items-center justify-center">
                    <div className="space-y-2">
                      <span className="block h-1 w-10 origin-center rounded-full bg-white"></span>
                      <span className="block h-1 w-8 origin-center rounded-full bg-white"></span>
                      <span className="block h-1 w-6 origin-center rounded-full bg-white"></span>
                    </div>
                  </div>
                </IconButton>
              )}

              {!open && (
                <img
                  src="/img/batukSmallLogo.png"
                  alt="batuk"
                  width="50px"
                  style={{ display: "flex", marginRight: "1rem" }}
                />
              )}
            </Box>
            {/* {!isMobile && (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap", // allows items to go to next line on small screens
                  gap: 2, // theme spacing (8px * 2 = 16px)
                  justifyContent: { xs: "center", sm: "space-around", md: "space-around" },
                  width: { xs: "100%", sm: "70%" }, // full width on small screens, 70% on larger
                  marginRight: { xs: 0, sm: "1rem" },
                  textAlign: { xs: "center", sm: "right" }, // center text on mobile
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
              >
                <div style={{ background: "#F8FAFC", borderRadius: "8px",color: "#4A2A7D",padding:"2px" ,minWidth: "120px",}}>Last Login: {new Date(last_login).toLocaleString()}</div>
                <div style={{ background: "#F8FAFC", borderRadius: "8px",color: "#4A2A7D",padding:"2px", minWidth: "120px",}}>IP: {last_login_ip}</div>
                <div style={{ background: "#F8FAFC", borderRadius: "8px",color: "#4A2A7D",padding:"2px", minWidth: "120px", }}>Session Expires: {timeLeft}</div>
                <div style={{ background: "#F8FAFC", borderRadius: "8px",color: "#4A2A7D",padding:"2px" ,minWidth: "120px",}}>Name: {name || "NA"}  </div>
              </Box>

          

            )} */}
            {/* 
            {!isMobile && (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 2,
                  justifyContent: "flex-start",
                  width: "100%",
                  textAlign: "right",
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
              >
                {[
                  { label: "Last Login", value: last_login ? new Date(last_login).toLocaleString() : "NA" },
                  { label: "Session Expires", value: timeLeft || "NA" },

                ].map((item, index) => (
                  <Stack direction="row" spacing={1}>
                    <Chip  label={`item.label:item.value`} />
                    <Chip  label="With Icon" variant="outlined" />
                  </Stack>
                ))}
              </Box>
            )} */}

            {/* {!isMobile && !isTab && last_login && timeLeft && (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1.5,
                  justifyContent: "flex-start",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                {[
                  {
                    label: "Last Login",
                    value: last_login
                      ? new Date(last_login).toLocaleString()
                      : "NA",
                  },
                  {
                    label: "Session Expires In",
                    value: timeLeft || "NA",
                  },
                ].map((item, index) => (
                  <Chip
                    key={index}
                    label={`${item.label}: ${item.value}`}
                    sx={{
                      backgroundColor: "#F8FAFC",
                      color: "#4A2A7D",
                      fontWeight: 500,
                    }}
                  />
                ))}
              </Box>
            )} */}

            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "0px",
              }}
            >

              <Tooltip title={roleResponse.name} >
               <Button
                  id="basic-button"
                  aria-controls={open1 ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open1 ? "true" : undefined}
                  onClick={handleClick}
                >
                    <img src="/icons/account.png" alt="cart Logo" width="30px" />
                  </Button>
                  <Box sx={{
                    backgroundColor: "#F8FAFC", // matching background
                    color: "#4A2A7D", // text color
                    borderRadius: "8px",
                    padding: "2px 2px",
                    minWidth: { xs: "100px", sm: "120px" }, // responsive min width
                    textAlign: "center", // centers text inside each box
                    flex: "1 1 auto", // allows boxes to shrink/grow
                  }}>{name || "aman"}</Box>

              </Tooltip>

              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open1}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <NavLink to="/resetpassword">
                  <MenuItem
                    sx={{
                      "&:hover": {
                        backgroundColor: navColor,
                        color: "white",
                      },
                    }}
                    onClick={handleClose}
                  >
                    Reset Password
                  </MenuItem>
                </NavLink>

                <MenuItem
                  sx={{
                    "&:hover": {
                      backgroundColor: navColor,
                      color: "white",
                    },
                  }}
                  onClick={callLogoutAPI}
                >
                  Logout
                </MenuItem>
              </Menu>
            </Box> */}

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "1rem",
              }}
            >
              <Tooltip title={roleResponse.name}>
                {/* <Button
                  id="basic-button"
                  aria-controls={open1 ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open1 ? "true" : undefined}
                  onClick={handleClick}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    color: "white", // ✅ text color
                    textTransform: "none",
                    fontSize: "16px", // ✅ bigger text
                    fontWeight: 500,
                  }}
                >
                  <img
                    src="/icons/account.png"
                    alt="account"
                    style={{
                      width: "32px",  // ✅ bigger logo
                      height: "32px",
                      borderRadius: "50%", // optional: makes it look like avatar
                      objectFit: "cover",
                    }}
                  />

                  <span >{name || "USER FDSFSD FDF DFS" || roleResponse.name}</span>

                  <span style={{
                    fontSize: "14px",
                    display: "inline-block",
                    transition: "transform 0.2s ease",
                    transform: open1 ? "rotate(180deg)" : "rotate(0deg)",
                  }}>▼</span>
                </Button> */}

                <Button
                  id="basic-button"
                  aria-controls={open1 ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open1 ? "true" : undefined}
                  onClick={handleClick}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    color: "white",
                    textTransform: "none",
                    fontSize: "16px",
                    fontWeight: 500,
                    maxWidth: "300px", // ✅ important
                  }}
                >
                  <img
                    src="/icons/account.png"
                    alt="account"
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      flexShrink: 0, // ✅ never shrink icon
                    }}
                  />

                  {/* ✅ THIS IS THE FIX */}
                  <span
                    style={{
                      flex: 1,
                      minWidth: 0,
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {name || "USER" || roleResponse.name}
                  </span>

                  <span
                    style={{
                      fontSize: "14px",
                      flexShrink: 0,
                      transition: "transform 0.2s ease",
                      transform: open1 ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  >
                    ▼
                  </span>
                </Button>
              </Tooltip>

              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open1}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <NavLink to="/resetpassword">
                  <MenuItem
                    onClick={handleClose}
                    sx={{
                      "&:hover": {
                        backgroundColor: navColor,
                        color: "white",
                      },
                    }}
                  >
                    Reset Password
                  </MenuItem>
                </NavLink>

                <MenuItem
                  onClick={callLogoutAPI}
                  sx={{
                    "&:hover": {
                      backgroundColor: navColor,
                      color: "white",
                    },
                  }}
                >
                  Logout
                </MenuItem>
              </Menu>
            </Box>

            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Chip
                id="basic-button"
                icon={
                  <img
                    src="/icons/account.png"
                    alt="account"
                    width="24px"
                    style={{ borderRadius: "50%" }}
                  />
                }
                label={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    {name || "USER"}
                    <span style={{ fontSize: "12px" }}>▼</span>
                  </Box>
                }
                onClick={handleClick}
                variant="outlined"
                sx={{
                  cursor: "pointer",
                  backgroundColor: "#F8FAFC",
                  color: "#4A2A7D",
                  borderColor: "#4A2A7D",
                  "&:hover": {
                    backgroundColor: "#4A2A7D",
                    color: "white",
                  },
                }}
              />

              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open1}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <NavLink to="/resetpassword">
                  <MenuItem onClick={handleClose}>Reset Password</MenuItem>
                </NavLink>

                <MenuItem onClick={callLogoutAPI}>
                  Logout
                </MenuItem>
              </Menu>
            </Box> */}
          </Box>
        </Toolbar>
      </AppBar>

      {/* ------------------------------------SIDEBAR-------------------------------------- */}

      <Drawer
        variant="permanent"
        open={open}
        sx={{ height: "100vh" }}
        isMobile={isMobile}
      >
        <DrawerHeader
          sx={{
            backgroundColor: navColor,
            display: "flex",
            // justifyContent: "center",
            justifyContent: isMobile ? "space-between" : "center",
            alignItems: "center",
          }}
        >
          <img src="/img/BatukLogo.png" alt="batuk" width="160px" />
          {isMobile && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              edge="start"
              sx={{
                marginRight: 3,
              }}
            >
              <div className="group flex  cursor-pointer items-center justify-center ">
                <div className="space-y-2">
                  <span className="block h-1 w-10 origin-center rounded-full bg-white "></span>
                  <span className="block h-1 w-8 origin-center rounded-full bg-white "></span>
                  <span className="block h-1 w-6 origin-center rounded-full bg-white "></span>
                </div>
              </div>
            </IconButton>
          )}
        </DrawerHeader>

        <List
          style={{ scrollbarWidth: "none" }}
          sx={{
            marginTop: "0px",
            overflowY: "auto",
            height: "100vh",
            paddingTop: "1px",
          }}
        >
          {filteredLinks?.map((item, index) => (
            <div key={index}>
              {item.name === "BUY" ? (
                // 🔽 PARTNER REPORT DROPDOWN
                <div>
                  <Button
                    onClick={toggleBuyDropdown}
                    sx={({ isActive }) => ({
                      width: "100%",
                      textDecoration: "none",
                      // color: isActive ? "white" : "inherit",
                      color: isActive ? "black" : "black",
                      backgroundColor: isActive ? "#4a2a7d" : "inherit",
                      p: 0,
                    })}
                  >
                    {open ? (
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2,
                          "&:hover": {
                            fontWeight: "bold",
                            backgroundColor: "#4a2a7d",
                            color: "white",
                            "& .MuiListItemIcon-root img": {
                              filter: "brightness(0) invert(1)",
                            },
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 2 : "auto",
                            justifyContent: "center",
                            // color:"white"
                          }}
                        >
                          <img
                            src={
                              window.location.pathname === item.link
                                ? item.img
                                : item.img
                            }
                            width={35}
                            alt=""
                          />
                        </ListItemIcon>
                        <h5
                          style={{
                            alignItems: "center",
                            display: open ? "" : "none",
                            margin: "0px",
                          }}
                        >
                          {item.label}
                        </h5>
                        <div className="w-full">
                          <FaAngleDown
                            size={20}
                            className={`float-right transition-transform ${
                              buyDropdownOpen ? "rotate-180" : ""
                            }`}
                          />
                        </div>
                      </ListItemButton>
                    ) : (
                      <Tooltip
                        title={item.label}
                        placement="right"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#4a2a7d",
                              color: "white",
                              fontSize: "0.8rem",
                              borderRadius: "4px",
                              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            },
                          },
                        }}
                      >
                        <ListItemButton
                          sx={{
                            minHeight: 48,
                            justifyContent: "center",
                            px: 2,
                            "&:hover": {
                              fontWeight: "bold",
                              backgroundColor: "#4a2a7d",
                              color: "white",
                              "& .MuiListItemIcon-root img": {
                                filter: "brightness(0) invert(1)",
                              },
                            },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 2 : "auto",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              src={
                                window.location.pathname === item.link
                                  ? item.img
                                  : item.img
                              }
                              width={35}
                              alt=""
                            />

                            <h5
                              style={{
                                alignItems: "center",
                                display: open ? "" : "none",
                                margin: "0px",
                              }}
                            >
                              {item.label}
                            </h5>
                            <div className=" w-full">
                              <FaAngleDown
                                size={20}
                                className={`float-right transition-transform ${
                                  buyDropdownOpen ? "rotate-180" : ""
                                } ${open ? "block" : "hidden"}`}
                              />
                            </div>
                          </ListItemIcon>
                        </ListItemButton>
                      </Tooltip>
                    )}
                  </Button>

                  {/* Dropdown Items */}
                  {buyDropdownOpen &&
                    filteredBuyLinks?.map((item) => (
                      <NavLink
                        key={item.name}
                        to={item.link}
                        style={({ isActive }) => ({
                          textDecoration: "none",
                          color: isActive ? "white" : "inherit",
                          backgroundColor: isActive ? "#4a2a7d" : "inherit",
                        })}
                      >
                        {open
                          ? ({ isActive }) => (
                              <ListItem
                                disablePadding
                                sx={{
                                  backgroundColor: isActive
                                    ? "#4a2a7d"
                                    : "inherit",
                                }}
                              >
                                <ListItemButton
                                  sx={{
                                    borderLeft: open ? "1px solid #4a2a7d" : "",
                                    ml: open ? 4 : 0,
                                    minHeight: 48,
                                    justifyContent: "initial",
                                    px: open ? 1 : 2,
                                    color: isActive ? "white" : "black", // Text color changes on active
                                    "&:hover": {
                                      fontWeight: "bold",
                                      backgroundColor: "#4a2a7d",
                                      color: "white", // Text turns white on hover
                                      "& .MuiListItemIcon-root img": {
                                        filter: "brightness(0) invert(1)", // Icon turns white on hover
                                      },
                                    },
                                  }}
                                  onClick={handleMenuClick}
                                >
                                  <ListItemIcon
                                    sx={{
                                      minWidth: 0,
                                      // mr: 2
                                      justifyContent: "center",
                                      "& img": {
                                        filter: isActive
                                          ? "brightness(0) invert(1)"
                                          : "none", // Icon turns white when active
                                      },
                                    }}
                                  >
                                    <img
                                      src={item.img}
                                      alt={`${item.label} Logo`}
                                      width={open ? "30px" : "35px"}
                                      style={{
                                        marginRight: "5px",
                                      }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    disableTypography
                                    primary={
                                      <Typography
                                        variant="body1"
                                        style={{
                                          fontSize: "2rem",
                                          display: open ? "block" : "none",
                                          color: "inherit", // Inherit color from parent (active/hover)
                                        }}
                                      >
                                        {/* {item.label} */}
                                        <span style={{ fontSize: 13 }}>
                                          {" "}
                                          {item.label}
                                        </span>
                                      </Typography>
                                    }
                                  />
                                </ListItemButton>
                              </ListItem>
                            )
                          : ({ isActive }) => (
                              <Tooltip
                                title={item.label}
                                placement="right"
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#4a2a7d", // Tooltip background color
                                      color: "white", // Tooltip text color
                                      fontSize: "0.8rem", // Adjust font size
                                      borderRadius: "4px", // Optional: Add rounded corners
                                      boxShadow:
                                        "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional: Add shadow
                                    },
                                  },
                                }}
                              >
                                <ListItem
                                  disablePadding
                                  sx={{
                                    backgroundColor: isActive
                                      ? "#4a2a7d"
                                      : "inherit",
                                  }}
                                >
                                  <ListItemButton
                                    sx={{
                                      borderLeft: open
                                        ? "1px solid #4a2a7d"
                                        : "",
                                      ml: open ? 4 : 0,
                                      minHeight: 48,
                                      justifyContent: "initial",
                                      px: open ? 1 : 2,
                                      color: isActive ? "white" : "black", // Text color changes on active
                                      "&:hover": {
                                        fontWeight: "bold",
                                        backgroundColor: "#4a2a7d",
                                        color: "white", // Text turns white on hover
                                        "& .MuiListItemIcon-root img": {
                                          filter: "brightness(0) invert(1)", // Icon turns white on hover
                                        },
                                      },
                                    }}
                                  >
                                    <ListItemIcon
                                      sx={{
                                        minWidth: 0,
                                        // mr: 2
                                        justifyContent: "center",
                                        "& img": {
                                          filter: isActive
                                            ? "brightness(0) invert(1)"
                                            : "none", // Icon turns white when active
                                        },
                                      }}
                                    >
                                      <img
                                        src={item.img}
                                        alt={`${item.label} Logo`}
                                        width={open ? "30px" : "35px"}
                                        style={{
                                          marginRight: "5px",
                                        }}
                                      />
                                    </ListItemIcon>
                                    <ListItemText
                                      disableTypography
                                      primary={
                                        <Typography
                                          variant="body1"
                                          style={{
                                            fontSize: "2rem",
                                            display: open ? "block" : "none",
                                            color: "inherit", // Inherit color from parent (active/hover)
                                          }}
                                        >
                                          {/* {item.label} */}
                                          <span style={{ fontSize: 13 }}>
                                            {" "}
                                            {item.label}
                                          </span>
                                        </Typography>
                                      }
                                    />
                                  </ListItemButton>
                                </ListItem>
                              </Tooltip>
                            )}
                      </NavLink>
                    ))}
                </div>
              ) : item.name === "SELL" ? (
                // 🔽 PARTNER REPORT DROPDOWN
                <div>
                  <Button
                    onClick={toggleSellDropdown}
                    sx={({ isActive }) => ({
                      width: "100%",
                      textDecoration: "none",
                      // color: isActive ? "white" : "inherit",
                      color: isActive ? "black" : "black",
                      backgroundColor: isActive ? "#4a2a7d" : "inherit",
                      p: 0,
                    })}
                  >
                    {open ? (
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2,
                          "&:hover": {
                            fontWeight: "bold",
                            backgroundColor: "#4a2a7d",
                            color: "white",
                            "& .MuiListItemIcon-root img": {
                              filter: "brightness(0) invert(1)",
                            },
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 2 : "auto",
                            justifyContent: "center",
                            // color:"white"
                          }}
                        >
                          <img
                            src={
                              window.location.pathname === item.link
                                ? item.img
                                : item.img
                            }
                            width={35}
                            alt=""
                          />
                        </ListItemIcon>
                        <h5
                          style={{
                            alignItems: "center",
                            display: open ? "" : "none",
                            margin: "0px",
                          }}
                        >
                          {item.label}
                        </h5>
                        <div className="w-full">
                          <FaAngleDown
                            size={20}
                            className={`float-right transition-transform ${
                              sellDropdownOpen ? "rotate-180" : ""
                            }`}
                          />
                        </div>
                      </ListItemButton>
                    ) : (
                      <Tooltip
                        title={item.label}
                        placement="right"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#4a2a7d",
                              color: "white",
                              fontSize: "0.8rem",
                              borderRadius: "4px",
                              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            },
                          },
                        }}
                      >
                        <ListItemButton
                          sx={{
                            minHeight: 48,
                            justifyContent: "center",
                            px: 2,
                            "&:hover": {
                              fontWeight: "bold",
                              backgroundColor: "#4a2a7d",
                              color: "white",
                              "& .MuiListItemIcon-root img": {
                                filter: "brightness(0) invert(1)",
                              },
                            },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 2 : "auto",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              src={
                                window.location.pathname === item.link
                                  ? item.img
                                  : item.img
                              }
                              width={35}
                              alt=""
                            />

                            <h5
                              style={{
                                alignItems: "center",
                                display: open ? "" : "none",
                                margin: "0px",
                              }}
                            >
                              {item.label}
                            </h5>
                            <div className=" w-full">
                              <FaAngleDown
                                size={20}
                                className={`float-right transition-transform ${
                                  sellDropdownOpen ? "rotate-180" : ""
                                } ${open ? "block" : "hidden"}`}
                              />
                            </div>
                          </ListItemIcon>
                        </ListItemButton>
                      </Tooltip>
                    )}
                  </Button>

                  {/* Dropdown Items */}
                  {sellDropdownOpen &&
                    filteredSellLinks?.map((item) => (
                      <NavLink
                        key={item.name}
                        to={item.link}
                        style={({ isActive }) => ({
                          textDecoration: "none",
                          color: isActive ? "white" : "inherit",
                          backgroundColor: isActive ? "#4a2a7d" : "inherit",
                        })}
                      >
                        {open
                          ? ({ isActive }) => (
                              <ListItem
                                disablePadding
                                sx={{
                                  backgroundColor: isActive
                                    ? "#4a2a7d"
                                    : "inherit",
                                }}
                              >
                                <ListItemButton
                                  sx={{
                                    borderLeft: open ? "1px solid #4a2a7d" : "",
                                    ml: open ? 4 : 0,
                                    minHeight: 48,
                                    justifyContent: "initial",
                                    px: open ? 1 : 2,
                                    color: isActive ? "white" : "black", // Text color changes on active
                                    "&:hover": {
                                      fontWeight: "bold",
                                      backgroundColor: "#4a2a7d",
                                      color: "white", // Text turns white on hover
                                      "& .MuiListItemIcon-root img": {
                                        filter: "brightness(0) invert(1)", // Icon turns white on hover
                                      },
                                    },
                                  }}
                                  onClick={handleMenuClick}
                                >
                                  <ListItemIcon
                                    sx={{
                                      minWidth: 0,
                                      // mr: 2
                                      justifyContent: "center",
                                      "& img": {
                                        filter: isActive
                                          ? "brightness(0) invert(1)"
                                          : "none", // Icon turns white when active
                                      },
                                    }}
                                  >
                                    <img
                                      src={item.img}
                                      alt={`${item.label} Logo`}
                                      width={open ? "30px" : "35px"}
                                      style={{
                                        marginRight: "5px",
                                      }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    disableTypography
                                    primary={
                                      <Typography
                                        variant="body1"
                                        style={{
                                          fontSize: "2rem",
                                          display: open ? "block" : "none",
                                          color: "inherit", // Inherit color from parent (active/hover)
                                        }}
                                      >
                                        {/* {item.label} */}
                                        <span style={{ fontSize: 13 }}>
                                          {" "}
                                          {item.label}
                                        </span>
                                      </Typography>
                                    }
                                  />
                                </ListItemButton>
                              </ListItem>
                            )
                          : ({ isActive }) => (
                              <Tooltip
                                title={item.label}
                                placement="right"
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#4a2a7d", // Tooltip background color
                                      color: "white", // Tooltip text color
                                      fontSize: "0.8rem", // Adjust font size
                                      borderRadius: "4px", // Optional: Add rounded corners
                                      boxShadow:
                                        "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional: Add shadow
                                    },
                                  },
                                }}
                              >
                                <ListItem
                                  disablePadding
                                  sx={{
                                    backgroundColor: isActive
                                      ? "#4a2a7d"
                                      : "inherit",
                                  }}
                                >
                                  <ListItemButton
                                    sx={{
                                      borderLeft: open
                                        ? "1px solid #4a2a7d"
                                        : "",
                                      ml: open ? 4 : 0,
                                      minHeight: 48,
                                      justifyContent: "initial",
                                      px: open ? 1 : 2,
                                      color: isActive ? "white" : "black", // Text color changes on active
                                      "&:hover": {
                                        fontWeight: "bold",
                                        backgroundColor: "#4a2a7d",
                                        color: "white", // Text turns white on hover
                                        "& .MuiListItemIcon-root img": {
                                          filter: "brightness(0) invert(1)", // Icon turns white on hover
                                        },
                                      },
                                    }}
                                  >
                                    <ListItemIcon
                                      sx={{
                                        minWidth: 0,
                                        // mr: 2
                                        justifyContent: "center",
                                        "& img": {
                                          filter: isActive
                                            ? "brightness(0) invert(1)"
                                            : "none", // Icon turns white when active
                                        },
                                      }}
                                    >
                                      <img
                                        src={item.img}
                                        alt={`${item.label} Logo`}
                                        width={open ? "30px" : "35px"}
                                        style={{
                                          marginRight: "5px",
                                        }}
                                      />
                                    </ListItemIcon>
                                    <ListItemText
                                      disableTypography
                                      primary={
                                        <Typography
                                          variant="body1"
                                          style={{
                                            fontSize: "2rem",
                                            display: open ? "block" : "none",
                                            color: "inherit", // Inherit color from parent (active/hover)
                                          }}
                                        >
                                          {/* {item.label} */}
                                          <span style={{ fontSize: 13 }}>
                                            {" "}
                                            {item.label}
                                          </span>
                                        </Typography>
                                      }
                                    />
                                  </ListItemButton>
                                </ListItem>
                              </Tooltip>
                            )}
                      </NavLink>
                    ))}
                </div>
              ) : item.name === "Redeem" ? (
                // 🔽 PARTNER REPORT DROPDOWN
                <div>
                  <Button
                    onClick={toggleRedeemDropdown}
                    sx={({ isActive }) => ({
                      width: "100%",
                      textDecoration: "none",
                      // color: isActive ? "white" : "inherit",
                      color: isActive ? "black" : "black",
                      backgroundColor: isActive ? "#4a2a7d" : "inherit",
                      p: 0,
                    })}
                  >
                    {open ? (
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2,
                          "&:hover": {
                            fontWeight: "bold",
                            backgroundColor: "#4a2a7d",
                            color: "white",
                            "& .MuiListItemIcon-root img": {
                              filter: "brightness(0) invert(1)",
                            },
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 2 : "auto",
                            justifyContent: "center",
                            // color:"white"
                          }}
                        >
                          <img
                            src={
                              window.location.pathname === item.link
                                ? item.img
                                : item.img
                            }
                            width={35}
                            alt=""
                          />
                        </ListItemIcon>
                        <h5
                          style={{
                            alignItems: "center",
                            display: open ? "" : "none",
                            margin: "0px",
                          }}
                        >
                          {item.label}
                        </h5>
                        <div className="w-full">
                          <FaAngleDown
                            size={20}
                            className={`float-right transition-transform ${
                              redeemDropdownOpen ? "rotate-180" : ""
                            }`}
                          />
                        </div>
                      </ListItemButton>
                    ) : (
                      <Tooltip
                        title={item.label}
                        placement="right"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#4a2a7d",
                              color: "white",
                              fontSize: "0.8rem",
                              borderRadius: "4px",
                              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            },
                          },
                        }}
                      >
                        <ListItemButton
                          sx={{
                            minHeight: 48,
                            justifyContent: "center",
                            px: 2,
                            "&:hover": {
                              fontWeight: "bold",
                              backgroundColor: "#4a2a7d",
                              color: "white",
                              "& .MuiListItemIcon-root img": {
                                filter: "brightness(0) invert(1)",
                              },
                            },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 2 : "auto",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              src={
                                window.location.pathname === item.link
                                  ? item.img
                                  : item.img
                              }
                              width={35}
                              alt=""
                            />

                            <h5
                              style={{
                                alignItems: "center",
                                display: open ? "" : "none",
                                margin: "0px",
                              }}
                            >
                              {item.label}
                            </h5>
                            <div className=" w-full">
                              <FaAngleDown
                                size={20}
                                className={`float-right transition-transform ${
                                  redeemDropdownOpen ? "rotate-180" : ""
                                } ${open ? "block" : "hidden"}`}
                              />
                            </div>
                          </ListItemIcon>
                        </ListItemButton>
                      </Tooltip>
                    )}
                  </Button>

                  {/* Dropdown Items */}
                  {redeemDropdownOpen &&
                    filteredRedeemLinks?.map((item) => (
                      <NavLink
                        key={item.name}
                        to={item.link}
                        style={({ isActive }) => ({
                          textDecoration: "none",
                          color: isActive ? "white" : "inherit",
                          backgroundColor: isActive ? "#4a2a7d" : "inherit",
                        })}
                      >
                        {open
                          ? ({ isActive }) => (
                              <ListItem
                                disablePadding
                                sx={{
                                  backgroundColor: isActive
                                    ? "#4a2a7d"
                                    : "inherit",
                                }}
                              >
                                <ListItemButton
                                  sx={{
                                    borderLeft: open ? "1px solid #4a2a7d" : "",
                                    ml: open ? 4 : 0,
                                    minHeight: 48,
                                    justifyContent: "initial",
                                    px: open ? 1 : 2,
                                    color: isActive ? "white" : "black", // Text color changes on active
                                    "&:hover": {
                                      fontWeight: "bold",
                                      backgroundColor: "#4a2a7d",
                                      color: "white", // Text turns white on hover
                                      "& .MuiListItemIcon-root img": {
                                        filter: "brightness(0) invert(1)", // Icon turns white on hover
                                      },
                                    },
                                  }}
                                  onClick={handleMenuClick}
                                >
                                  <ListItemIcon
                                    sx={{
                                      minWidth: 0,
                                      // mr: 2
                                      justifyContent: "center",
                                      "& img": {
                                        filter: isActive
                                          ? "brightness(0) invert(1)"
                                          : "none", // Icon turns white when active
                                      },
                                    }}
                                  >
                                    <img
                                      src={item.img}
                                      alt={`${item.label} Logo`}
                                      width={open ? "30px" : "35px"}
                                      style={{
                                        marginRight: "5px",
                                      }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    disableTypography
                                    primary={
                                      <Typography
                                        variant="body1"
                                        style={{
                                          fontSize: "2rem",
                                          display: open ? "block" : "none",
                                          color: "inherit", // Inherit color from parent (active/hover)
                                        }}
                                      >
                                        {/* {item.label} */}
                                        <span style={{ fontSize: 13 }}>
                                          {" "}
                                          {item.label}
                                        </span>
                                      </Typography>
                                    }
                                  />
                                </ListItemButton>
                              </ListItem>
                            )
                          : ({ isActive }) => (
                              <Tooltip
                                title={item.label}
                                placement="right"
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#4a2a7d", // Tooltip background color
                                      color: "white", // Tooltip text color
                                      fontSize: "0.8rem", // Adjust font size
                                      borderRadius: "4px", // Optional: Add rounded corners
                                      boxShadow:
                                        "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional: Add shadow
                                    },
                                  },
                                }}
                              >
                                <ListItem
                                  disablePadding
                                  sx={{
                                    backgroundColor: isActive
                                      ? "#4a2a7d"
                                      : "inherit",
                                  }}
                                >
                                  <ListItemButton
                                    sx={{
                                      borderLeft: open
                                        ? "1px solid #4a2a7d"
                                        : "",
                                      ml: open ? 4 : 0,
                                      minHeight: 48,
                                      justifyContent: "initial",
                                      px: open ? 1 : 2,
                                      color: isActive ? "white" : "black", // Text color changes on active
                                      "&:hover": {
                                        fontWeight: "bold",
                                        backgroundColor: "#4a2a7d",
                                        color: "white", // Text turns white on hover
                                        "& .MuiListItemIcon-root img": {
                                          filter: "brightness(0) invert(1)", // Icon turns white on hover
                                        },
                                      },
                                    }}
                                  >
                                    <ListItemIcon
                                      sx={{
                                        minWidth: 0,
                                        // mr: 2
                                        justifyContent: "center",
                                        "& img": {
                                          filter: isActive
                                            ? "brightness(0) invert(1)"
                                            : "none", // Icon turns white when active
                                        },
                                      }}
                                    >
                                      <img
                                        src={item.img}
                                        alt={`${item.label} Logo`}
                                        width={open ? "30px" : "35px"}
                                        style={{
                                          marginRight: "5px",
                                        }}
                                      />
                                    </ListItemIcon>
                                    <ListItemText
                                      disableTypography
                                      primary={
                                        <Typography
                                          variant="body1"
                                          style={{
                                            fontSize: "2rem",
                                            display: open ? "block" : "none",
                                            color: "inherit", // Inherit color from parent (active/hover)
                                          }}
                                        >
                                          {/* {item.label} */}
                                          <span style={{ fontSize: 13 }}>
                                            {" "}
                                            {item.label}
                                          </span>
                                        </Typography>
                                      }
                                    />
                                  </ListItemButton>
                                </ListItem>
                              </Tooltip>
                            )}
                      </NavLink>
                    ))}
                </div>
              ) : item.name === "Content" ? (
                // 🔽 PARTNER REPORT DROPDOWN
                <div>
                  <Button
                    onClick={toggleContentDropdown}
                    sx={({ isActive }) => ({
                      width: "100%",
                      textDecoration: "none",
                      // color: isActive ? "white" : "inherit",
                      color: isActive ? "black" : "black",
                      backgroundColor: isActive ? "#4a2a7d" : "inherit",
                      p: 0,
                    })}
                  >
                    {open ? (
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2,
                          "&:hover": {
                            fontWeight: "bold",
                            backgroundColor: "#4a2a7d",
                            color: "white",
                            "& .MuiListItemIcon-root img": {
                              filter: "brightness(0) invert(1)",
                            },
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 2 : "auto",
                            justifyContent: "center",
                            // color:"white"
                          }}
                        >
                          <img
                            src={
                              window.location.pathname === item.link
                                ? item.img
                                : item.img
                            }
                            width={35}
                            alt=""
                          />
                        </ListItemIcon>
                        <h5
                          style={{
                            alignItems: "center",
                            display: open ? "" : "none",
                            margin: "0px",
                          }}
                        >
                          {item.label}
                        </h5>
                        <div className="w-full">
                          <FaAngleDown
                            size={20}
                            className={`float-right transition-transform ${
                              contentDropdownOpen ? "rotate-180" : ""
                            }`}
                          />
                        </div>
                      </ListItemButton>
                    ) : (
                      <Tooltip
                        title={item.label}
                        placement="right"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#4a2a7d",
                              color: "white",
                              fontSize: "0.8rem",
                              borderRadius: "4px",
                              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            },
                          },
                        }}
                      >
                        <ListItemButton
                          sx={{
                            minHeight: 48,
                            justifyContent: "center",
                            px: 2,
                            "&:hover": {
                              fontWeight: "bold",
                              backgroundColor: "#4a2a7d",
                              color: "white",
                              "& .MuiListItemIcon-root img": {
                                filter: "brightness(0) invert(1)",
                              },
                            },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 2 : "auto",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              src={
                                window.location.pathname === item.link
                                  ? item.img
                                  : item.img
                              }
                              width={35}
                              alt=""
                            />

                            <h5
                              style={{
                                alignItems: "center",
                                display: open ? "" : "none",
                                margin: "0px",
                              }}
                            >
                              {item.label}
                            </h5>
                            <div className=" w-full">
                              <FaAngleDown
                                size={20}
                                className={`float-right transition-transform ${
                                  contentDropdownOpen ? "rotate-180" : ""
                                } ${open ? "block" : "hidden"}`}
                              />
                            </div>
                          </ListItemIcon>
                        </ListItemButton>
                      </Tooltip>
                    )}
                  </Button>

                  {/* Dropdown Items */}
                  {contentDropdownOpen &&
                    filteredContentLinks?.map((item) => (
                      <NavLink
                        key={item.name}
                        to={item.link}
                        style={({ isActive }) => ({
                          textDecoration: "none",
                          color: isActive ? "white" : "inherit",
                          backgroundColor: isActive ? "#4a2a7d" : "inherit",
                        })}
                      >
                        {open
                          ? ({ isActive }) => (
                              <ListItem
                                disablePadding
                                sx={{
                                  backgroundColor: isActive
                                    ? "#4a2a7d"
                                    : "inherit",
                                }}
                              >
                                <ListItemButton
                                  sx={{
                                    borderLeft: open ? "1px solid #4a2a7d" : "",
                                    ml: open ? 4 : 0,
                                    minHeight: 48,
                                    justifyContent: "initial",
                                    px: open ? 1 : 2,
                                    color: isActive ? "white" : "black", // Text color changes on active
                                    "&:hover": {
                                      fontWeight: "bold",
                                      backgroundColor: "#4a2a7d",
                                      color: "white", // Text turns white on hover
                                      "& .MuiListItemIcon-root img": {
                                        filter: "brightness(0) invert(1)", // Icon turns white on hover
                                      },
                                    },
                                  }}
                                  onClick={handleMenuClick}
                                >
                                  <ListItemIcon
                                    sx={{
                                      minWidth: 0,
                                      // mr: 2
                                      justifyContent: "center",
                                      "& img": {
                                        filter: isActive
                                          ? "brightness(0) invert(1)"
                                          : "none", // Icon turns white when active
                                      },
                                    }}
                                  >
                                    <img
                                      src={item.img}
                                      alt={`${item.label} Logo`}
                                      width={open ? "30px" : "35px"}
                                      style={{
                                        marginRight: "5px",
                                      }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    disableTypography
                                    primary={
                                      <Typography
                                        variant="body1"
                                        style={{
                                          fontSize: "2rem",
                                          display: open ? "block" : "none",
                                          color: "inherit", // Inherit color from parent (active/hover)
                                        }}
                                      >
                                        {/* {item.label} */}
                                        <span style={{ fontSize: 13 }}>
                                          {" "}
                                          {item.label}
                                        </span>
                                      </Typography>
                                    }
                                  />
                                </ListItemButton>
                              </ListItem>
                            )
                          : ({ isActive }) => (
                              <Tooltip
                                title={item.label}
                                placement="right"
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#4a2a7d", // Tooltip background color
                                      color: "white", // Tooltip text color
                                      fontSize: "0.8rem", // Adjust font size
                                      borderRadius: "4px", // Optional: Add rounded corners
                                      boxShadow:
                                        "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional: Add shadow
                                    },
                                  },
                                }}
                              >
                                <ListItem
                                  disablePadding
                                  sx={{
                                    backgroundColor: isActive
                                      ? "#4a2a7d"
                                      : "inherit",
                                  }}
                                >
                                  <ListItemButton
                                    sx={{
                                      borderLeft: open
                                        ? "1px solid #4a2a7d"
                                        : "",
                                      ml: open ? 4 : 0,
                                      minHeight: 48,
                                      justifyContent: "initial",
                                      px: open ? 1 : 2,
                                      color: isActive ? "white" : "black", // Text color changes on active
                                      "&:hover": {
                                        fontWeight: "bold",
                                        backgroundColor: "#4a2a7d",
                                        color: "white", // Text turns white on hover
                                        "& .MuiListItemIcon-root img": {
                                          filter: "brightness(0) invert(1)", // Icon turns white on hover
                                        },
                                      },
                                    }}
                                  >
                                    <ListItemIcon
                                      sx={{
                                        minWidth: 0,
                                        // mr: 2
                                        justifyContent: "center",
                                        "& img": {
                                          filter: isActive
                                            ? "brightness(0) invert(1)"
                                            : "none", // Icon turns white when active
                                        },
                                      }}
                                    >
                                      <img
                                        src={item.img}
                                        alt={`${item.label} Logo`}
                                        width={open ? "30px" : "35px"}
                                        style={{
                                          marginRight: "5px",
                                        }}
                                      />
                                    </ListItemIcon>
                                    <ListItemText
                                      disableTypography
                                      primary={
                                        <Typography
                                          variant="body1"
                                          style={{
                                            fontSize: "2rem",
                                            display: open ? "block" : "none",
                                            color: "inherit", // Inherit color from parent (active/hover)
                                          }}
                                        >
                                          {/* {item.label} */}
                                          <span style={{ fontSize: 13 }}>
                                            {" "}
                                            {item.label}
                                          </span>
                                        </Typography>
                                      }
                                    />
                                  </ListItemButton>
                                </ListItem>
                              </Tooltip>
                            )}
                      </NavLink>
                    ))}
                </div>
              ) : item.name === "Partners" ? (
                // 🔽 PARTNER REPORT DROPDOWN
                <div>
                  <Button
                    onClick={togglePartnerDropdown}
                    sx={({ isActive }) => ({
                      width: "100%",
                      textDecoration: "none",
                      // color: isActive ? "white" : "inherit",
                      color: isActive ? "black" : "black",
                      backgroundColor: isActive ? "#4a2a7d" : "inherit",
                      p: 0,
                    })}
                  >
                    {open ? (
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2,
                          "&:hover": {
                            fontWeight: "bold",
                            backgroundColor: "#4a2a7d",
                            color: "white",
                            "& .MuiListItemIcon-root img": {
                              filter: "brightness(0) invert(1)",
                            },
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 2 : "auto",
                            justifyContent: "center",
                            // color:"white"
                          }}
                        >
                          <img
                            src={
                              window.location.pathname === item.link
                                ? item.img
                                : item.img
                            }
                            width={35}
                            alt=""
                          />
                        </ListItemIcon>
                        <h5
                          style={{
                            alignItems: "center",
                            display: open ? "" : "none",
                            margin: "0px",
                          }}
                        >
                          {item.label}
                        </h5>
                        <div className="w-full">
                          <FaAngleDown
                            size={20}
                            className={`float-right transition-transform ${
                              partnerDropdownOpen ? "rotate-180" : ""
                            }`}
                          />
                        </div>
                      </ListItemButton>
                    ) : (
                      <Tooltip
                        title={item.label}
                        placement="right"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#4a2a7d",
                              color: "white",
                              fontSize: "0.8rem",
                              borderRadius: "4px",
                              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            },
                          },
                        }}
                      >
                        <ListItemButton
                          sx={{
                            minHeight: 48,
                            justifyContent: "center",
                            px: 2,
                            "&:hover": {
                              fontWeight: "bold",
                              backgroundColor: "#4a2a7d",
                              color: "white",
                              "& .MuiListItemIcon-root img": {
                                filter: "brightness(0) invert(1)",
                              },
                            },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 2 : "auto",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              src={
                                window.location.pathname === item.link
                                  ? item.img
                                  : item.img
                              }
                              width={35}
                              alt=""
                            />

                            <h5
                              style={{
                                alignItems: "center",
                                display: open ? "" : "none",
                                margin: "0px",
                              }}
                            >
                              {item.label}
                            </h5>
                            <div className=" w-full">
                              <FaAngleDown
                                size={20}
                                className={`float-right transition-transform ${
                                  partnerDropdownOpen ? "rotate-180" : ""
                                } ${open ? "block" : "hidden"}`}
                              />
                            </div>
                          </ListItemIcon>
                        </ListItemButton>
                      </Tooltip>
                    )}
                  </Button>

                  {/* Dropdown Items */}
                  {partnerDropdownOpen &&
                    filteredPartnerLinks?.map((item) => (
                      <NavLink
                        key={item.name}
                        to={item.link}
                        style={({ isActive }) => ({
                          textDecoration: "none",
                          color: isActive ? "white" : "inherit",
                          backgroundColor: isActive ? "#4a2a7d" : "inherit",
                        })}
                      >
                        {open
                          ? ({ isActive }) => (
                              <ListItem
                                disablePadding
                                sx={{
                                  backgroundColor: isActive
                                    ? "#4a2a7d"
                                    : "inherit",
                                }}
                              >
                                <ListItemButton
                                  sx={{
                                    borderLeft: open ? "1px solid #4a2a7d" : "",
                                    ml: open ? 4 : 0,
                                    minHeight: 48,
                                    justifyContent: "initial",
                                    px: open ? 1 : 2,
                                    color: isActive ? "white" : "black", // Text color changes on active
                                    "&:hover": {
                                      fontWeight: "bold",
                                      backgroundColor: "#4a2a7d",
                                      color: "white", // Text turns white on hover
                                      "& .MuiListItemIcon-root img": {
                                        filter: "brightness(0) invert(1)", // Icon turns white on hover
                                      },
                                    },
                                  }}
                                  onClick={handleMenuClick}
                                >
                                  <ListItemIcon
                                    sx={{
                                      minWidth: 0,
                                      // mr: 2
                                      justifyContent: "center",
                                      "& img": {
                                        filter: isActive
                                          ? "brightness(0) invert(1)"
                                          : "none", // Icon turns white when active
                                      },
                                    }}
                                  >
                                    <img
                                      src={item.img}
                                      alt={`${item.label} Logo`}
                                      width={open ? "30px" : "35px"}
                                      style={{
                                        marginRight: "5px",
                                      }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    disableTypography
                                    primary={
                                      <Typography
                                        variant="body1"
                                        style={{
                                          fontSize: "2rem",
                                          display: open ? "block" : "none",
                                          color: "inherit", // Inherit color from parent (active/hover)
                                        }}
                                      >
                                        {/* {item.label} */}
                                        <span style={{ fontSize: 13 }}>
                                          {" "}
                                          {item.label}
                                        </span>
                                      </Typography>
                                    }
                                  />
                                </ListItemButton>
                              </ListItem>
                            )
                          : ({ isActive }) => (
                              <Tooltip
                                title={item.label}
                                placement="right"
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#4a2a7d", // Tooltip background color
                                      color: "white", // Tooltip text color
                                      fontSize: "0.8rem", // Adjust font size
                                      borderRadius: "4px", // Optional: Add rounded corners
                                      boxShadow:
                                        "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional: Add shadow
                                    },
                                  },
                                }}
                              >
                                <ListItem
                                  disablePadding
                                  sx={{
                                    backgroundColor: isActive
                                      ? "#4a2a7d"
                                      : "inherit",
                                  }}
                                >
                                  <ListItemButton
                                    sx={{
                                      borderLeft: open
                                        ? "1px solid #4a2a7d"
                                        : "",
                                      ml: open ? 4 : 0,
                                      minHeight: 48,
                                      justifyContent: "initial",
                                      px: open ? 1 : 2,
                                      color: isActive ? "white" : "black", // Text color changes on active
                                      "&:hover": {
                                        fontWeight: "bold",
                                        backgroundColor: "#4a2a7d",
                                        color: "white", // Text turns white on hover
                                        "& .MuiListItemIcon-root img": {
                                          filter: "brightness(0) invert(1)", // Icon turns white on hover
                                        },
                                      },
                                    }}
                                  >
                                    <ListItemIcon
                                      sx={{
                                        minWidth: 0,
                                        // mr: 2
                                        justifyContent: "center",
                                        "& img": {
                                          filter: isActive
                                            ? "brightness(0) invert(1)"
                                            : "none", // Icon turns white when active
                                        },
                                      }}
                                    >
                                      <img
                                        src={item.img}
                                        alt={`${item.label} Logo`}
                                        width={open ? "30px" : "35px"}
                                        style={{
                                          marginRight: "5px",
                                        }}
                                      />
                                    </ListItemIcon>
                                    <ListItemText
                                      disableTypography
                                      primary={
                                        <Typography
                                          variant="body1"
                                          style={{
                                            fontSize: "2rem",
                                            display: open ? "block" : "none",
                                            color: "inherit", // Inherit color from parent (active/hover)
                                          }}
                                        >
                                          {/* {item.label} */}
                                          <span style={{ fontSize: 13 }}>
                                            {" "}
                                            {item.label}
                                          </span>
                                        </Typography>
                                      }
                                    />
                                  </ListItemButton>
                                </ListItem>
                              </Tooltip>
                            )}
                      </NavLink>
                    ))}
                </div>
              ) : item.name === "Reports" ? (
                // 🔽 REPORTS DROPDOWN
                <div>
                  {/* Toggle Button */}
                  <Button
                    onClick={toggleDropdown}
                    sx={({ isActive }) => ({
                      width: "100%",
                      textDecoration: "none",
                      // color: isActive ? "white" : "inherit",
                      color: isActive ? "black" : "black",
                      backgroundColor: isActive ? "#4a2a7d" : "inherit",
                      p: 0,
                    })}
                  >
                    {open ? (
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2,
                          "&:hover": {
                            fontWeight: "bold",
                            backgroundColor: "#4a2a7d",
                            color: "white", // Text turns white on hover
                            "& .MuiListItemIcon-root img": {
                              filter: "brightness(0) invert(1)", // Icon turns white on hover
                            },
                          },
                        }}
                        onClick={handleMenuClick}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 2 : "auto",
                            justifyContent: "center",
                            // color:"white"
                          }}
                        >
                          <img
                            src={
                              window.location.pathname === item.link
                                ? item.img
                                : item.img
                            }
                            width={35}
                            alt=""
                          />
                          {/* <FaHome size={30} /> */}
                        </ListItemIcon>
                        <h5
                          style={{
                            alignItems: "center",
                            display: open ? "" : "none",
                            margin: "0px",
                          }}
                        >
                          {item.label}
                        </h5>
                        <div className=" w-full">
                          <FaAngleDown
                            size={20}
                            className={`float-right transition-transform ${
                              dropdownOpen ? "rotate-180" : ""
                            } ${open ? "block" : "hidden"}`}
                          />
                        </div>
                      </ListItemButton>
                    ) : (
                      <Tooltip
                        title={item.label}
                        placement="right"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#4a2a7d", // Tooltip background color
                              color: "white", // Tooltip text color
                              fontSize: "0.8rem", // Adjust font size
                              borderRadius: "4px", // Optional: Add rounded corners
                              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional: Add shadow
                            },
                          },
                        }}
                      >
                        <ListItemButton
                          sx={{
                            minHeight: 48,
                            justifyContent: open ? "initial" : "center",
                            px: 2,
                            "&:hover": {
                              fontWeight: "bold",
                              backgroundColor: "#4a2a7d",
                              color: "white", // Text turns white on hover
                              "& .MuiListItemIcon-root img": {
                                filter: "brightness(0) invert(1)", // Icon turns white on hover
                              },
                            },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 2 : "auto",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              src={
                                window.location.pathname === item.link
                                  ? item.img
                                  : item.img
                              }
                              width={35}
                              alt=""
                            />
                          </ListItemIcon>
                          <h5
                            style={{
                              alignItems: "center",
                              display: open ? "" : "none",
                              margin: "0px",
                            }}
                          >
                            {item.label}
                          </h5>
                          <div className=" w-full">
                            <FaAngleDown
                              size={20}
                              className={`float-right transition-transform ${
                                dropdownOpen ? "rotate-180" : ""
                              } ${open ? "block" : "hidden"}`}
                            />
                          </div>
                        </ListItemButton>
                      </Tooltip>
                    )}
                  </Button>

                  {/* Dropdown Items */}
                  {dropdownOpen &&
                    filteredReportsLinks?.map((item) => (
                      <NavLink
                        key={item.name}
                        to={item.link}
                        style={({ isActive }) => ({
                          textDecoration: "none",
                          color: isActive ? "white" : "inherit",
                          backgroundColor: isActive ? "#4a2a7d" : "inherit",
                        })}
                      >
                        {open
                          ? ({ isActive }) => (
                              <ListItem
                                disablePadding
                                sx={{
                                  backgroundColor: isActive
                                    ? "#4a2a7d"
                                    : "inherit",
                                }}
                              >
                                <ListItemButton
                                  sx={{
                                    borderLeft: open ? "1px solid #4a2a7d" : "",
                                    ml: open ? 4 : 0,
                                    minHeight: 48,
                                    justifyContent: "initial",
                                    px: open ? 1 : 2,
                                    color: isActive ? "white" : "black", // Text color changes on active
                                    "&:hover": {
                                      fontWeight: "bold",
                                      backgroundColor: "#4a2a7d",
                                      color: "white", // Text turns white on hover
                                      "& .MuiListItemIcon-root img": {
                                        filter: "brightness(0) invert(1)", // Icon turns white on hover
                                      },
                                    },
                                  }}
                                  onClick={handleMenuClick}
                                >
                                  <ListItemIcon
                                    sx={{
                                      minWidth: 0,
                                      // mr: 2
                                      justifyContent: "center",
                                      "& img": {
                                        filter: isActive
                                          ? "brightness(0) invert(1)"
                                          : "none", // Icon turns white when active
                                      },
                                    }}
                                  >
                                    <img
                                      src={item.img}
                                      alt={`${item.label} Logo`}
                                      width={open ? "30px" : "35px"}
                                      style={{
                                        marginRight: "5px",
                                      }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    disableTypography
                                    primary={
                                      <Typography
                                        variant="body1"
                                        style={{
                                          fontSize: "2rem",
                                          display: open ? "block" : "none",
                                          color: "inherit", // Inherit color from parent (active/hover)
                                        }}
                                      >
                                        {/* {item.label} */}
                                        <span style={{ fontSize: 13 }}>
                                          {" "}
                                          {item.label}
                                        </span>
                                      </Typography>
                                    }
                                  />
                                </ListItemButton>
                              </ListItem>
                            )
                          : ({ isActive }) => (
                              <Tooltip
                                title={item.label}
                                placement="right"
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#4a2a7d", // Tooltip background color
                                      color: "white", // Tooltip text color
                                      fontSize: "0.8rem", // Adjust font size
                                      borderRadius: "4px", // Optional: Add rounded corners
                                      boxShadow:
                                        "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional: Add shadow
                                    },
                                  },
                                }}
                              >
                                <ListItem
                                  disablePadding
                                  sx={{
                                    backgroundColor: isActive
                                      ? "#4a2a7d"
                                      : "inherit",
                                  }}
                                >
                                  <ListItemButton
                                    sx={{
                                      borderLeft: open
                                        ? "1px solid #4a2a7d"
                                        : "",
                                      ml: open ? 4 : 0,
                                      minHeight: 48,
                                      justifyContent: "initial",
                                      px: open ? 1 : 2,
                                      color: isActive ? "white" : "black", // Text color changes on active
                                      "&:hover": {
                                        fontWeight: "bold",
                                        backgroundColor: "#4a2a7d",
                                        color: "white", // Text turns white on hover
                                        "& .MuiListItemIcon-root img": {
                                          filter: "brightness(0) invert(1)", // Icon turns white on hover
                                        },
                                      },
                                    }}
                                  >
                                    <ListItemIcon
                                      sx={{
                                        minWidth: 0,
                                        // mr: 2
                                        justifyContent: "center",
                                        "& img": {
                                          filter: isActive
                                            ? "brightness(0) invert(1)"
                                            : "none", // Icon turns white when active
                                        },
                                      }}
                                    >
                                      <img
                                        src={item.img}
                                        alt={`${item.label} Logo`}
                                        width={open ? "30px" : "35px"}
                                        style={{
                                          marginRight: "5px",
                                        }}
                                      />
                                    </ListItemIcon>
                                    <ListItemText
                                      disableTypography
                                      primary={
                                        <Typography
                                          variant="body1"
                                          style={{
                                            fontSize: "2rem",
                                            display: open ? "block" : "none",
                                            color: "inherit", // Inherit color from parent (active/hover)
                                          }}
                                        >
                                          {/* {item.label} */}
                                          <span style={{ fontSize: 13 }}>
                                            {" "}
                                            {item.label}
                                          </span>
                                        </Typography>
                                      }
                                    />
                                  </ListItemButton>
                                </ListItem>
                              </Tooltip>
                            )}
                      </NavLink>
                    ))}
                </div>
              ) : item.name === "User" ? (
                <div>
                  {/* Toggle Button */}
                  <Button
                    onClick={toggleUserDropdown}
                    sx={({ isActive }) => ({
                      width: "100%",
                      textDecoration: "none",
                      // color: isActive ? "white" : "inherit",
                      color: isActive ? "black" : "black",
                      backgroundColor: isActive ? "#4a2a7d" : "inherit",
                      p: 0,
                    })}
                  >
                    {open ? (
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2,
                          "&:hover": {
                            fontWeight: "bold",
                            backgroundColor: "#4a2a7d",
                            color: "white", // Text turns white on hover
                            "& .MuiListItemIcon-root img": {
                              filter: "brightness(0) invert(1)", // Icon turns white on hover
                            },
                          },
                        }}
                        onClick={handleMenuClick}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 2 : "auto",
                            justifyContent: "center",
                            // color:"white"
                          }}
                        >
                          <img
                            src={
                              window.location.pathname === item.link
                                ? item.img
                                : item.img
                            }
                            width={35}
                            alt=""
                          />
                          {/* <FaHome size={30} /> */}
                        </ListItemIcon>
                        <h5
                          style={{
                            alignItems: "center",
                            display: open ? "" : "none",
                            margin: "0px",
                          }}
                        >
                          {item.label}
                        </h5>
                        <div className=" w-full">
                          <FaAngleDown
                            size={20}
                            className={`float-right transition-transform ${
                              userDropdownOpen ? "rotate-180" : ""
                            } ${open ? "block" : "hidden"}`}
                          />
                        </div>
                      </ListItemButton>
                    ) : (
                      <Tooltip
                        title={item.label}
                        placement="right"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#4a2a7d", // Tooltip background color
                              color: "white", // Tooltip text color
                              fontSize: "0.8rem", // Adjust font size
                              borderRadius: "4px", // Optional: Add rounded corners
                              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional: Add shadow
                            },
                          },
                        }}
                      >
                        <ListItemButton
                          sx={{
                            minHeight: 48,
                            justifyContent: open ? "initial" : "center",
                            px: 2,
                            "&:hover": {
                              fontWeight: "bold",
                              backgroundColor: "#4a2a7d",
                              color: "white", // Text turns white on hover
                              "& .MuiListItemIcon-root img": {
                                filter: "brightness(0) invert(1)", // Icon turns white on hover
                              },
                            },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 2 : "auto",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              src={
                                window.location.pathname === item.link
                                  ? item.img
                                  : item.img
                              }
                              width={35}
                              alt=""
                            />
                          </ListItemIcon>
                          <h5
                            style={{
                              alignItems: "center",
                              display: open ? "" : "none",
                              margin: "0px",
                            }}
                          >
                            {item.label}
                          </h5>
                          <div className=" w-full">
                            <FaAngleDown
                              size={20}
                              className={`float-right transition-transform ${
                                userDropdownOpen ? "rotate-180" : ""
                              } ${open ? "block" : "hidden"}`}
                            />
                          </div>
                        </ListItemButton>
                      </Tooltip>
                    )}
                  </Button>

                  {/* Dropdown Items */}
                  {userDropdownOpen &&
                    filteredUserLinks?.map((item) => (
                      <NavLink
                        key={item.name}
                        to={item.link}
                        style={({ isActive }) => ({
                          textDecoration: "none",
                          color: isActive ? "white" : "inherit",
                          backgroundColor: isActive ? "#4a2a7d" : "inherit",
                        })}
                      >
                        {open
                          ? ({ isActive }) => (
                              <ListItem
                                disablePadding
                                sx={{
                                  backgroundColor: isActive
                                    ? "#4a2a7d"
                                    : "inherit",
                                }}
                              >
                                <ListItemButton
                                  sx={{
                                    borderLeft: open ? "1px solid #4a2a7d" : "",
                                    ml: open ? 4 : 0,
                                    minHeight: 48,
                                    justifyContent: "initial",
                                    px: open ? 1 : 2,
                                    color: isActive ? "white" : "black", // Text color changes on active
                                    "&:hover": {
                                      fontWeight: "bold",
                                      backgroundColor: "#4a2a7d",
                                      color: "white", // Text turns white on hover
                                      "& .MuiListItemIcon-root img": {
                                        filter: "brightness(0) invert(1)", // Icon turns white on hover
                                      },
                                    },
                                  }}
                                  onClick={handleMenuClick}
                                >
                                  <ListItemIcon
                                    sx={{
                                      minWidth: 0,
                                      // mr: 2
                                      justifyContent: "center",
                                      "& img": {
                                        filter: isActive
                                          ? "brightness(0) invert(1)"
                                          : "none", // Icon turns white when active
                                      },
                                    }}
                                  >
                                    <img
                                      src={item.img}
                                      alt={`${item.label} Logo`}
                                      width={open ? "30px" : "35px"}
                                      style={{
                                        marginRight: "5px",
                                      }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    disableTypography
                                    primary={
                                      <Typography
                                        variant="body1"
                                        style={{
                                          fontSize: "2rem",
                                          display: open ? "block" : "none",
                                          color: "inherit", // Inherit color from parent (active/hover)
                                        }}
                                      >
                                        {/* {item.label} */}
                                        <span style={{ fontSize: 13 }}>
                                          {" "}
                                          {item.label}
                                        </span>
                                      </Typography>
                                    }
                                  />
                                </ListItemButton>
                              </ListItem>
                            )
                          : ({ isActive }) => (
                              <Tooltip
                                title={item.label}
                                placement="right"
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#4a2a7d", // Tooltip background color
                                      color: "white", // Tooltip text color
                                      fontSize: "0.8rem", // Adjust font size
                                      borderRadius: "4px", // Optional: Add rounded corners
                                      boxShadow:
                                        "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional: Add shadow
                                    },
                                  },
                                }}
                              >
                                <ListItem
                                  disablePadding
                                  sx={{
                                    backgroundColor: isActive
                                      ? "#4a2a7d"
                                      : "inherit",
                                  }}
                                >
                                  <ListItemButton
                                    sx={{
                                      borderLeft: open
                                        ? "1px solid #4a2a7d"
                                        : "",
                                      ml: open ? 4 : 0,
                                      minHeight: 48,
                                      justifyContent: "initial",
                                      px: open ? 1 : 2,
                                      color: isActive ? "white" : "black", // Text color changes on active
                                      "&:hover": {
                                        fontWeight: "bold",
                                        backgroundColor: "#4a2a7d",
                                        color: "white", // Text turns white on hover
                                        "& .MuiListItemIcon-root img": {
                                          filter: "brightness(0) invert(1)", // Icon turns white on hover
                                        },
                                      },
                                    }}
                                  >
                                    <ListItemIcon
                                      sx={{
                                        minWidth: 0,
                                        // mr: 2
                                        justifyContent: "center",
                                        "& img": {
                                          filter: isActive
                                            ? "brightness(0) invert(1)"
                                            : "none", // Icon turns white when active
                                        },
                                      }}
                                    >
                                      <img
                                        src={item.img}
                                        alt={`${item.label} Logo`}
                                        width={open ? "30px" : "35px"}
                                        style={{
                                          marginRight: "5px",
                                        }}
                                      />
                                    </ListItemIcon>
                                    <ListItemText
                                      disableTypography
                                      primary={
                                        <Typography
                                          variant="body1"
                                          style={{
                                            fontSize: "2rem",
                                            display: open ? "block" : "none",
                                            color: "inherit", // Inherit color from parent (active/hover)
                                          }}
                                        >
                                          {/* {item.label} */}
                                          <span style={{ fontSize: 13 }}>
                                            {" "}
                                            {item.label}
                                          </span>
                                        </Typography>
                                      }
                                    />
                                  </ListItemButton>
                                </ListItem>
                              </Tooltip>
                            )}
                      </NavLink>
                    ))}
                </div>
              ) : item.name === "Jewellery" ? (
                <div>
                  {/* Toggle Button */}
                  <Button
                    onClick={toggleJewelleryDropdown}
                    sx={({ isActive }) => ({
                      width: "100%",
                      textDecoration: "none",
                      // color: isActive ? "white" : "inherit",
                      color: isActive ? "black" : "black",
                      backgroundColor: isActive ? "#4a2a7d" : "inherit",
                      p: 0,
                    })}
                  >
                    {open ? (
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2,
                          "&:hover": {
                            fontWeight: "bold",
                            backgroundColor: "#4a2a7d",
                            color: "white", // Text turns white on hover
                            "& .MuiListItemIcon-root img": {
                              filter: "brightness(0) invert(1)", // Icon turns white on hover
                            },
                          },
                        }}
                        onClick={handleMenuClick}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 2 : "auto",
                            justifyContent: "center",
                            // color:"white"
                          }}
                        >
                          <img
                            src={
                              window.location.pathname === item.link
                                ? item.img
                                : item.img
                            }
                            width={35}
                            alt=""
                          />
                          {/* <FaHome size={30} /> */}
                        </ListItemIcon>
                        <h5
                          style={{
                            alignItems: "center",
                            display: open ? "" : "none",
                            margin: "0px",
                          }}
                        >
                          {item.label}
                        </h5>
                        <div className=" w-full">
                          <FaAngleDown
                            size={20}
                            className={`float-right transition-transform ${
                              jewelleryDropdownOpen ? "rotate-180" : ""
                            } ${open ? "block" : "hidden"}`}
                          />
                        </div>
                      </ListItemButton>
                    ) : (
                      <Tooltip
                        title={item.label}
                        placement="right"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#4a2a7d", // Tooltip background color
                              color: "white", // Tooltip text color
                              fontSize: "0.8rem", // Adjust font size
                              borderRadius: "4px", // Optional: Add rounded corners
                              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional: Add shadow
                            },
                          },
                        }}
                      >
                        <ListItemButton
                          sx={{
                            minHeight: 48,
                            justifyContent: open ? "initial" : "center",
                            px: 2,
                            "&:hover": {
                              fontWeight: "bold",
                              backgroundColor: "#4a2a7d",
                              color: "white", // Text turns white on hover
                              "& .MuiListItemIcon-root img": {
                                filter: "brightness(0) invert(1)", // Icon turns white on hover
                              },
                            },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 2 : "auto",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              src={
                                window.location.pathname === item.link
                                  ? item.img
                                  : item.img
                              }
                              width={35}
                              alt=""
                            />
                          </ListItemIcon>
                          <h5
                            style={{
                              alignItems: "center",
                              display: open ? "" : "none",
                              margin: "0px",
                            }}
                          >
                            {item.label}
                          </h5>
                          <div className=" w-full">
                            <FaAngleDown
                              size={20}
                              className={`float-right transition-transform ${
                                jewelleryDropdownOpen ? "rotate-180" : ""
                              } ${open ? "block" : "hidden"}`}
                            />
                          </div>
                        </ListItemButton>
                      </Tooltip>
                    )}
                  </Button>

                  {/* Dropdown Items */}
                  {jewelleryDropdownOpen &&
                    filteredJewelleryLinks?.map((item) => (
                      <NavLink
                        key={item.name}
                        to={item.link}
                        style={({ isActive }) => ({
                          textDecoration: "none",
                          color: isActive ? "white" : "inherit",
                          backgroundColor: isActive ? "#4a2a7d" : "inherit",
                        })}
                      >
                        {open
                          ? ({ isActive }) => (
                              <ListItem
                                disablePadding
                                sx={{
                                  backgroundColor: isActive
                                    ? "#4a2a7d"
                                    : "inherit",
                                }}
                              >
                                <ListItemButton
                                  sx={{
                                    borderLeft: open ? "1px solid #4a2a7d" : "",
                                    ml: open ? 4 : 0,
                                    minHeight: 48,
                                    justifyContent: "initial",
                                    px: open ? 1 : 2,
                                    color: isActive ? "white" : "black", // Text color changes on active
                                    "&:hover": {
                                      fontWeight: "bold",
                                      backgroundColor: "#4a2a7d",
                                      color: "white", // Text turns white on hover
                                      "& .MuiListItemIcon-root img": {
                                        filter: "brightness(0) invert(1)", // Icon turns white on hover
                                      },
                                    },
                                  }}
                                  onClick={handleMenuClick}
                                >
                                  <ListItemIcon
                                    sx={{
                                      minWidth: 0,
                                      // mr: 2
                                      justifyContent: "center",
                                      "& img": {
                                        filter: isActive
                                          ? "brightness(0) invert(1)"
                                          : "none", // Icon turns white when active
                                      },
                                    }}
                                  >
                                    <img
                                      src={item.img}
                                      alt={`${item.label} Logo`}
                                      width={open ? "30px" : "35px"}
                                      style={{
                                        marginRight: "5px",
                                      }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    disableTypography
                                    primary={
                                      <Typography
                                        variant="body1"
                                        style={{
                                          fontSize: "2rem",
                                          display: open ? "block" : "none",
                                          color: "inherit", // Inherit color from parent (active/hover)
                                        }}
                                      >
                                        {/* {item.label} */}
                                        <span style={{ fontSize: 13 }}>
                                          {" "}
                                          {item.label}
                                        </span>
                                      </Typography>
                                    }
                                  />
                                </ListItemButton>
                              </ListItem>
                            )
                          : ({ isActive }) => (
                              <Tooltip
                                title={item.label}
                                placement="right"
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#4a2a7d", // Tooltip background color
                                      color: "white", // Tooltip text color
                                      fontSize: "0.8rem", // Adjust font size
                                      borderRadius: "4px", // Optional: Add rounded corners
                                      boxShadow:
                                        "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional: Add shadow
                                    },
                                  },
                                }}
                              >
                                <ListItem
                                  disablePadding
                                  sx={{
                                    backgroundColor: isActive
                                      ? "#4a2a7d"
                                      : "inherit",
                                  }}
                                >
                                  <ListItemButton
                                    sx={{
                                      borderLeft: open
                                        ? "1px solid #4a2a7d"
                                        : "",
                                      ml: open ? 4 : 0,
                                      minHeight: 48,
                                      justifyContent: "initial",
                                      px: open ? 1 : 2,
                                      color: isActive ? "white" : "black", // Text color changes on active
                                      "&:hover": {
                                        fontWeight: "bold",
                                        backgroundColor: "#4a2a7d",
                                        color: "white", // Text turns white on hover
                                        "& .MuiListItemIcon-root img": {
                                          filter: "brightness(0) invert(1)", // Icon turns white on hover
                                        },
                                      },
                                    }}
                                  >
                                    <ListItemIcon
                                      sx={{
                                        minWidth: 0,
                                        // mr: 2
                                        justifyContent: "center",
                                        "& img": {
                                          filter: isActive
                                            ? "brightness(0) invert(1)"
                                            : "none", // Icon turns white when active
                                        },
                                      }}
                                    >
                                      <img
                                        src={item.img}
                                        alt={`${item.label} Logo`}
                                        width={open ? "30px" : "35px"}
                                        style={{
                                          marginRight: "5px",
                                        }}
                                      />
                                    </ListItemIcon>
                                    <ListItemText
                                      disableTypography
                                      primary={
                                        <Typography
                                          variant="body1"
                                          style={{
                                            fontSize: "2rem",
                                            display: open ? "block" : "none",
                                            color: "inherit", // Inherit color from parent (active/hover)
                                          }}
                                        >
                                          {/* {item.label} */}
                                          <span style={{ fontSize: 13 }}>
                                            {" "}
                                            {item.label}
                                          </span>
                                        </Typography>
                                      }
                                    />
                                  </ListItemButton>
                                </ListItem>
                              </Tooltip>
                            )}
                      </NavLink>
                    ))}
                </div>
              ) : item.name === "Operations" ? (
                <div>
                  {/* Toggle Button */}
                  <Button
                    onClick={toggleOperationsDropdown}
                    sx={({ isActive }) => ({
                      width: "100%",
                      textDecoration: "none",
                      // color: isActive ? "white" : "inherit",
                      color: isActive ? "black" : "black",
                      backgroundColor: isActive ? "#4a2a7d" : "inherit",
                      p: 0,
                    })}
                  >
                    {open ? (
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2,
                          "&:hover": {
                            fontWeight: "bold",
                            backgroundColor: "#4a2a7d",
                            color: "white", // Text turns white on hover
                            "& .MuiListItemIcon-root img": {
                              filter: "brightness(0) invert(1)", // Icon turns white on hover
                            },
                          },
                        }}
                        onClick={handleMenuClick}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 2 : "auto",
                            justifyContent: "center",
                            // color:"white"
                          }}
                        >
                          <img
                            src={
                              window.location.pathname === item.link
                                ? item.img
                                : item.img
                            }
                            width={35}
                            alt=""
                          />
                          {/* <FaHome size={30} /> */}
                        </ListItemIcon>
                        <h5
                          style={{
                            alignItems: "center",
                            display: open ? "" : "none",
                            margin: "0px",
                          }}
                        >
                          {item.label}
                        </h5>
                        <div className=" w-full">
                          <FaAngleDown
                            size={20}
                            className={`float-right transition-transform ${
                              operationsDropdownOpen ? "rotate-180" : ""
                            } ${open ? "block" : "hidden"}`}
                          />
                        </div>
                      </ListItemButton>
                    ) : (
                      <Tooltip
                        title={item.label}
                        placement="right"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#4a2a7d", // Tooltip background color
                              color: "white", // Tooltip text color
                              fontSize: "0.8rem", // Adjust font size
                              borderRadius: "4px", // Optional: Add rounded corners
                              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional: Add shadow
                            },
                          },
                        }}
                      >
                        <ListItemButton
                          sx={{
                            minHeight: 48,
                            justifyContent: open ? "initial" : "center",
                            px: 2,
                            "&:hover": {
                              fontWeight: "bold",
                              backgroundColor: "#4a2a7d",
                              color: "white", // Text turns white on hover
                              "& .MuiListItemIcon-root img": {
                                filter: "brightness(0) invert(1)", // Icon turns white on hover
                              },
                            },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 2 : "auto",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              src={
                                window.location.pathname === item.link
                                  ? item.img
                                  : item.img
                              }
                              width={35}
                              alt=""
                            />
                          </ListItemIcon>
                          <h5
                            style={{
                              alignItems: "center",
                              display: open ? "" : "none",
                              margin: "0px",
                            }}
                          >
                            {item.label}
                          </h5>
                          <div className=" w-full">
                            <FaAngleDown
                              size={20}
                              className={`float-right transition-transform ${
                                operationsDropdownOpen ? "rotate-180" : ""
                              } ${open ? "block" : "hidden"}`}
                            />
                          </div>
                        </ListItemButton>
                      </Tooltip>
                    )}
                  </Button>

                  {/* Dropdown Items */}
                  {operationsDropdownOpen &&
                    filteredOperationsLinks?.map((item) => (
                      <NavLink
                        key={item.name}
                        to={item.link}
                        style={({ isActive }) => ({
                          textDecoration: "none",
                          color: isActive ? "white" : "inherit",
                          backgroundColor: isActive ? "#4a2a7d" : "inherit",
                        })}
                      >
                        {open
                          ? ({ isActive }) => (
                              <ListItem
                                disablePadding
                                sx={{
                                  backgroundColor: isActive
                                    ? "#4a2a7d"
                                    : "inherit",
                                }}
                              >
                                <ListItemButton
                                  sx={{
                                    borderLeft: open ? "1px solid #4a2a7d" : "",
                                    ml: open ? 4 : 0,
                                    minHeight: 48,
                                    justifyContent: "initial",
                                    px: open ? 1 : 2,
                                    color: isActive ? "white" : "black", // Text color changes on active
                                    "&:hover": {
                                      fontWeight: "bold",
                                      backgroundColor: "#4a2a7d",
                                      color: "white", // Text turns white on hover
                                      "& .MuiListItemIcon-root img": {
                                        filter: "brightness(0) invert(1)", // Icon turns white on hover
                                      },
                                    },
                                  }}
                                  onClick={handleMenuClick}
                                >
                                  <ListItemIcon
                                    sx={{
                                      minWidth: 0,
                                      // mr: 2
                                      justifyContent: "center",
                                      "& img": {
                                        filter: isActive
                                          ? "brightness(0) invert(1)"
                                          : "none", // Icon turns white when active
                                      },
                                    }}
                                  >
                                    <img
                                      src={item.img}
                                      alt={`${item.label} Logo`}
                                      width={open ? "30px" : "35px"}
                                      style={{
                                        marginRight: "5px",
                                      }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    disableTypography
                                    primary={
                                      <Typography
                                        variant="body1"
                                        style={{
                                          fontSize: "2rem",
                                          display: open ? "block" : "none",
                                          color: "inherit", // Inherit color from parent (active/hover)
                                        }}
                                      >
                                        {/* {item.label} */}
                                        <span style={{ fontSize: 13 }}>
                                          {" "}
                                          {item.label}
                                        </span>
                                      </Typography>
                                    }
                                  />
                                </ListItemButton>
                              </ListItem>
                            )
                          : ({ isActive }) => (
                              <Tooltip
                                title={item.label}
                                placement="right"
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#4a2a7d", // Tooltip background color
                                      color: "white", // Tooltip text color
                                      fontSize: "0.8rem", // Adjust font size
                                      borderRadius: "4px", // Optional: Add rounded corners
                                      boxShadow:
                                        "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional: Add shadow
                                    },
                                  },
                                }}
                              >
                                <ListItem
                                  disablePadding
                                  sx={{
                                    backgroundColor: isActive
                                      ? "#4a2a7d"
                                      : "inherit",
                                  }}
                                >
                                  <ListItemButton
                                    sx={{
                                      borderLeft: open
                                        ? "1px solid #4a2a7d"
                                        : "",
                                      ml: open ? 4 : 0,
                                      minHeight: 48,
                                      justifyContent: "initial",
                                      px: open ? 1 : 2,
                                      color: isActive ? "white" : "black", // Text color changes on active
                                      "&:hover": {
                                        fontWeight: "bold",
                                        backgroundColor: "#4a2a7d",
                                        color: "white", // Text turns white on hover
                                        "& .MuiListItemIcon-root img": {
                                          filter: "brightness(0) invert(1)", // Icon turns white on hover
                                        },
                                      },
                                    }}
                                  >
                                    <ListItemIcon
                                      sx={{
                                        minWidth: 0,
                                        // mr: 2
                                        justifyContent: "center",
                                        "& img": {
                                          filter: isActive
                                            ? "brightness(0) invert(1)"
                                            : "none", // Icon turns white when active
                                        },
                                      }}
                                    >
                                      <img
                                        src={item.img}
                                        alt={`${item.label} Logo`}
                                        width={open ? "30px" : "35px"}
                                        style={{
                                          marginRight: "5px",
                                        }}
                                      />
                                    </ListItemIcon>
                                    <ListItemText
                                      disableTypography
                                      primary={
                                        <Typography
                                          variant="body1"
                                          style={{
                                            fontSize: "2rem",
                                            display: open ? "block" : "none",
                                            color: "inherit", // Inherit color from parent (active/hover)
                                          }}
                                        >
                                          {/* {item.label} */}
                                          <span style={{ fontSize: 13 }}>
                                            {" "}
                                            {item.label}
                                          </span>
                                        </Typography>
                                      }
                                    />
                                  </ListItemButton>
                                </ListItem>
                              </Tooltip>
                            )}
                      </NavLink>
                    ))}
                </div>
              ) : (
                // 🔹 DEFAULT NON-DROPDOWN ITEMS
                <NavLink
                  key={item.name}
                  to={item.link}
                  style={({ isActive }) => ({
                    textDecoration: "none",
                    color: isActive ? "white" : "inherit",
                    backgroundColor: isActive ? "#4a2a7d" : "inherit",
                    // border: isActive ? "px solid red" : "none",
                  })}
                >
                  {open
                    ? ({ isActive }) => (
                        <ListItem
                          disablePadding
                          sx={{
                            backgroundColor: isActive ? "#4a2a7d" : "inherit",
                            borderBottom:
                              item.name == "Bajaj Dashboard"
                                ? "1px solid #4a2a7d"
                                : "none", // Add bottom border except for "role"
                          }}
                        >
                          <ListItemButton
                            sx={{
                              minHeight: 48,
                              justifyContent: "initial",
                              px: 2,
                              color: isActive ? "white" : "black", // Text color changes on active
                              "&:hover": {
                                fontWeight: "bold",
                                backgroundColor: "#4a2a7d",
                                color: "white", // Text turns white on hover
                                "& .MuiListItemIcon-root img": {
                                  filter: "brightness(0) invert(1)", // Icon turns white on hover
                                },
                              },
                            }}
                            onClick={handleMenuClick}
                          >
                            <ListItemIcon
                              sx={{
                                minWidth: 0,
                                mr: 2,
                                justifyContent: "center",
                                "& img": {
                                  filter: isActive
                                    ? "brightness(0) invert(1)"
                                    : "none", // Icon turns white when active
                                },
                              }}
                            >
                              <img
                                src={item.img}
                                alt={`${item.label} Logo`}
                                width="35px"
                                style={{
                                  marginRight: "0rem",
                                }}
                              />
                            </ListItemIcon>
                            <ListItemText
                              disableTypography
                              primary={
                                <Typography
                                  variant="body2"
                                  style={{
                                    display: open ? "block" : "none",
                                    color: "inherit", // Inherit color from parent (active/hover)
                                  }}
                                >
                                  {item.label}
                                </Typography>
                              }
                            />
                          </ListItemButton>
                        </ListItem>
                      )
                    : ({ isActive }) => (
                        <Tooltip
                          title={item.label}
                          placement="right"
                          componentsProps={{
                            tooltip: {
                              sx: {
                                backgroundColor: "#4a2a7d", // Tooltip background color
                                color: "white", // Tooltip text color
                                fontSize: "0.8rem", // Adjust font size
                                borderRadius: "4px", // Optional: Add rounded corners
                                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional: Add shadow
                              },
                            },
                          }}
                        >
                          <ListItem
                            disablePadding
                            sx={{
                              backgroundColor: isActive ? "#4a2a7d" : "inherit",
                            }}
                          >
                            <ListItemButton
                              sx={{
                                minHeight: 48,
                                justifyContent: "initial",
                                px: 2,
                                color: isActive ? "white" : "black", // Text color changes on active
                                "&:hover": {
                                  fontWeight: "bold",
                                  backgroundColor: "#4a2a7d",
                                  color: "white", // Text turns white on hover
                                  "& .MuiListItemIcon-root img": {
                                    filter: "brightness(0) invert(1)", // Icon turns white on hover
                                  },
                                },
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: 2,
                                  justifyContent: "center",
                                  "& img": {
                                    filter: isActive
                                      ? "brightness(0) invert(1)"
                                      : "none", // Icon turns white when active
                                  },
                                }}
                              >
                                <img
                                  src={item.img}
                                  alt={`${item.label} Logo`}
                                  width="35px"
                                  style={{
                                    marginRight: "0rem",
                                  }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                disableTypography
                                primary={
                                  <Typography
                                    variant="body2"
                                    style={{
                                      display: open ? "block" : "none",
                                      color: "inherit", // Inherit color from parent (active/hover)
                                    }}
                                  >
                                    {item.label}
                                  </Typography>
                                }
                              />
                            </ListItemButton>
                          </ListItem>
                        </Tooltip>
                      )}
                </NavLink>
              )}
            </div>
          ))}
        </List>
      </Drawer>

      {/* main components */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: isMobile ? 2 : 5,
          // backgroundColor:"red",
          overflow: "auto",
        }}
      >
        <DrawerHeader />
        <Outlet />
      </Box>
    </Box>
  );
}
